import { render, staticRenderFns } from "./IndicacaoVaga.vue?vue&type=template&id=74764190&scoped=true"
import script from "./IndicacaoVaga.vue?vue&type=script&lang=js"
export * from "./IndicacaoVaga.vue?vue&type=script&lang=js"
import style0 from "./IndicacaoVaga.vue?vue&type=style&index=0&id=74764190&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74764190",
  null
  
)

export default component.exports